import {get} from 'lodash';

export default (
  state = {},
  {coachId, commissionLastWeek, bonusesLastMonth, incomeLastMonth}: any,
) => {
  return {
    ...state,
    allEarnings: {
      ...get(state, 'allEarnings', {}),
      [coachId]: {
        commissionLastWeek,
        bonusesLastMonth,
        incomeLastMonth,
      },
    },
  };
};
